<template>
  <div class="page-container">
    <div class="main-content">
      <!-- Export Button -->
      <div class="row export-button-container">
        <div class="col-lg-10" />
        <div class="col-lg-2">
          <pl-button
            class="export-button"
            @click.native="show_export_data_modal = true"
          >
            Export
          </pl-button>
        </div>
        <ExportEngagementDataModal
          :fileName="exportable_file_name"
          :getFile="fetchClassCSVdata"
          @close="show_export_data_modal = false"
          :showButtons="Boolean(getCurrentRT.submissions.length)"
          v-if="show_export_data_modal"
        />
      </div>

      <!-- Assessments Grid -->
      <table>
        <tbody>
          <tr>
            <td
              rowspan="2"
              class="b student-name-row clickable"
              @click="sortByClick('StudentName')"
            >
              <div class="flex justify-center items-center">
                <span class="mh2">
                  Student Name
                  <i
                    v-if="!dataTableCaretAscStudentsNames"
                    class="fa fa-caret-up"
                  ></i>
                  <i
                    v-if="dataTableCaretAscStudentsNames"
                    class="fa fa-caret-down"
                  ></i>
                </span>
                <div
                  v-if="getCurrentRT.enable_annonymous"
                  v-my-tooltip="{
                    content: tooltip_text,
                    placement: 'top-start',
                    classes: ['info'],
                  }"
                  class="clickable eye-container"
                  @click="revealNames"
                >
                  <i v-if="!reveal_names" class="fa fa-eye" />
                  <i v-else class="fa fa-eye-slash" />
                </div>
              </div>
            </td>
            <td colspan="4" class="submission submission-row b">Submission</td>
            <td colspan="1" class="read-row b">Read</td>
            <td colspan="4" class="comments comments-row b">Comments</td>
            <td colspan="4" class="feedback assessment-row b">Feedback</td>
          </tr>
          <tr class="b">
            <td
              class="submission clickable"
              colspan="2"
              @click="sortByClick('Complete')"
            >
              Complete?
              <i v-if="!dataTableCaretAscComplete" class="fa fa-caret-up"></i>
              <i v-if="dataTableCaretAscComplete" class="fa fa-caret-down"></i>
            </td>
            <td
              class="submission clickable"
              colspan="1"
              @click="sortByClick('Words')"
            >
              Words
              <i v-if="!dataTableCaretAscWords" class="fa fa-caret-up"></i>
              <i v-if="dataTableCaretAscWords" class="fa fa-caret-down"></i>
            </td>
            <td
              class="submission clickable"
              colspan="1"
              @click="sortByClick('SubmissionStar')"
            >
              <i
                class="fa fa-star star ml1 mb1 dib v-mid pt1"
                aria-hidden="true"
              />
              <i
                v-if="!dataTableCaretAscSubmissionStar"
                class="fa fa-caret-up"
              ></i>
              <i
                v-if="dataTableCaretAscSubmissionStar"
                class="fa fa-caret-down"
              ></i>
            </td>
            <td
              class="clickable"
              colspan="1"
              @click="sortByClick('PercentageRead')"
            >
              %
              <i
                v-if="!dataTableCaretAscPercentageRead"
                class="fa fa-caret-up"
              ></i>
              <i
                v-if="dataTableCaretAscPercentageRead"
                class="fa fa-caret-down"
              ></i>
            </td>
            <td
              class="comments clickable"
              colspan="2"
              @click="sortByClick('CommentsNumber')"
            >
              #
              <i
                v-if="!dataTableCaretAscCommentsNumber"
                class="fa fa-caret-up"
              ></i>
              <i
                v-if="dataTableCaretAscCommentsNumber"
                class="fa fa-caret-down"
              ></i>
            </td>
            <td
              class="comments clickable"
              colspan="2"
              @click="sortByClick('Average_lenght')"
            >
              Length
              <i
                v-if="!dataTableCaretAscCommentsAverageLenght"
                class="fa fa-caret-up"
              ></i>
              <i
                v-if="dataTableCaretAscCommentsAverageLenght"
                class="fa fa-caret-down"
              ></i>
            </td>
            <td
              class="feedback clickable"
              colspan="4"
              @click="sortByClick('FeedbackComplete')"
            >
              Complete?
              <i
                v-if="!dataTableCaretAscFeedbackComplete"
                class="fa fa-caret-up"
              ></i>
              <i
                v-if="dataTableCaretAscFeedbackComplete"
                class="fa fa-caret-down"
              ></i>
            </td>
          </tr>
          <template v-for="(participant, index) in dataTableSorted">
            <tr :key="index">
              <td>
                <div class="student-container">
                  <img
                    v-if="reveal_names"
                    :src="participant.avatar"
                    class="avatar-circlex avatar-size ma1"
                    alt="avatar"
                  />
                  <img
                    v-else
                    :src="participant.anonymous_identity.avatar_url"
                    class="avatar-circlex avatar-size ma1"
                    alt="avatar"
                  />
                  <span
                    class="student-name-cell"
                    :title="
                      reveal_names
                        ? participant.name
                        : participant.anonymous_identity.name
                    "
                  >
                    {{
                      reveal_names
                        ? participant.name
                        : participant.anonymous_identity.name
                    }}
                  </span>
                </div>
              </td>
              <template v-for="(value, key) in participant.submission">
                <td
                  v-if="key === 'complete'"
                  class="submission b"
                  colspan="2"
                  :key="value + key"
                >
                  <span v-if="value === 'yes'">
                    <img
                      src="/static/live_discussion/check_mark-blue.svg"
                      alt="check-mark"
                      class="avatar"
                    />
                    <span
                      class="link-student-submission"
                      @click="
                        redirectToStudentFeedback(
                          participant.submissionID,
                          'comments'
                        )
                      "
                    >
                      (view)
                    </span>
                  </span>
                  <span v-else class="empty-assessment">-</span>
                </td>
                <td v-else class="submission b" :key="value + key">
                  <template v-if="key === 'star'">
                    <span v-if="value === true">
                      <img
                        src="/static/live_discussion/check_mark-yellow.svg"
                        alt="check-mark"
                        class="avatar"
                      />
                    </span>
                    <span v-else class="empty-assessment">-</span>
                  </template>
                  <template v-else>
                    {{ value }}
                  </template>
                </td>
              </template>

              <td class="b" :key="index">{{ participant.read }}%</td>
              <template v-for="(value, index) in participant.comments">
                <td class="comments b" colspan="2" :key="index">{{ value }}</td>
              </template>
              <template v-for="(value, index) in participant.feedback">
                <td class="feedback b" colspan="4" :key="index">
                  <span v-if="value === 'yes'">
                    <img
                      src="/static/live_discussion/check_mark.svg"
                      alt="check-mark"
                      class="avatar"
                    />
                    <span
                      class="link-student-feedback"
                      @click="
                        redirectToStudentFeedback(
                          participant.submissionID,
                          'assessment'
                        )
                      "
                    >
                      (view)
                    </span>
                  </span>
                  <span v-else class="empty-assessment">-</span>
                </td>
              </template>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment';

  import ExportEngagementDataModal from 'components/modals/exportEngagementDataModal';
  import roundtableServices from 'features/onlineRoundtables/onlineRoundtables.services.js';

  export default {
    components: {
      ExportEngagementDataModal,
    },
    data() {
      return {
        dataTableCaretAscStudentsNames: true,
        dataTableCaretAscComplete: false,
        dataTableCaretAscWords: false,
        dataTableCaretAscSubmissionStar: false,
        dataTableCaretAscPercentageRead: false,
        dataTableCaretAscCommentsNumber: false,
        dataTableCaretAscCommentsAverageLenght: false,
        dataTableCaretAscFeedbackComplete: false,
        dataTableSorted: [],
        show_export_data_modal: false,
        reveal_names: false,
      };
    },
    props: {
      table_data: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      ...mapGetters([
        'getCurrentDiscussion',
        'getClassSummaryLD',
        'getCurrentRT',
      ]),
      tooltip_text() {
        if (this.reveal_names) {
          return "Hide Names: <br /> You will go back to seeing <br />your students' anonymous names";
        }
        return 'Reveal Names: <br /> <strong>Only you</strong> will be able to see <br />the real names of your students';
      },
      exportable_file_name() {
        const date = moment().format('L'); // MM-DD-YYYY
        const fileName = `${this.getCurrentRT.title} - Written - Export ${date}.csv`;
        return fileName;
      },
    },
    methods: {
      sortByClick(sort) {
        switch (sort) {
          case 'StudentName':
            if (this.dataTableCaretAscStudentsNames) {
              if (this.reveal_names) {
                this.dataTableSorted.sort((a, b) =>
                  b.name.localeCompare(a.name)
                );
              } else {
                // sort by anonymous name
                this.dataTableSorted.sort((a, b) =>
                  b.anonymous_identity.name.localeCompare(
                    a.anonymous_identity.name
                  )
                );
              }
              this.dataTableCaretAscStudentsNames = false;
            } else {
              if (this.reveal_names) {
                this.dataTableSorted.sort((a, b) =>
                  a.name.localeCompare(b.name)
                );
              } else {
                this.dataTableSorted.sort((a, b) =>
                  a.anonymous_identity.name.localeCompare(
                    b.anonymous_identity.name
                  )
                );
              }
              this.dataTableCaretAscStudentsNames = true;
            }
            break;
          case 'Complete':
            if (this.dataTableCaretAscComplete) {
              this.dataTableSorted.sort((a, b) =>
                a.submission.complete.localeCompare(b.submission.complete)
              );
              this.dataTableCaretAscComplete = false;
            } else {
              this.dataTableSorted.sort((a, b) =>
                b.submission.complete.localeCompare(a.submission.complete)
              );
              this.dataTableCaretAscComplete = true;
            }
            break;
          case 'Words':
            if (this.dataTableCaretAscWords) {
              this.dataTableSorted.sort(
                (a, b) => b.submission.words - a.submission.words
              );
              this.dataTableCaretAscWords = false;
            } else {
              this.dataTableSorted.sort(
                (a, b) => a.submission.words - b.submission.words
              );
              this.dataTableCaretAscWords = true;
            }
            break;
          case 'SubmissionStar':
            if (this.dataTableCaretAscSubmissionStar) {
              this.dataTableSorted.sort(
                (a, b) => a.submission.star - b.submission.star
              );
              this.dataTableCaretAscSubmissionStar = false;
            } else {
              this.dataTableSorted.sort(
                (a, b) => b.submission.star - a.submission.star
              );
              this.dataTableCaretAscSubmissionStar = true;
            }
            break;
          case 'PercentageRead':
            if (this.dataTableCaretAscPercentageRead) {
              this.dataTableSorted.sort((a, b) => b.read - a.read);
              this.dataTableCaretAscPercentageRead = false;
            } else {
              this.dataTableSorted.sort((a, b) => a.read - b.read);
              this.dataTableCaretAscPercentageRead = true;
            }
            break;
          case 'CommentsNumber':
            if (this.dataTableCaretAscCommentsNumber) {
              this.dataTableSorted.sort(
                (a, b) => b.comments.number - a.comments.number
              );
              this.dataTableCaretAscCommentsNumber = false;
            } else {
              this.dataTableSorted.sort(
                (a, b) => a.comments.number - b.comments.number
              );
              this.dataTableCaretAscCommentsNumber = true;
            }
            break;
          case 'Average_lenght':
            if (this.dataTableCaretAscCommentsAverageLenght) {
              this.dataTableSorted.sort(
                (a, b) => b.comments.average_lenght - a.comments.average_lenght
              );
              this.dataTableCaretAscCommentsAverageLenght = false;
            } else {
              this.dataTableSorted.sort(
                (a, b) => a.comments.average_lenght - b.comments.average_lenght
              );
              this.dataTableCaretAscCommentsAverageLenght = true;
            }
            break;
          case 'FeedbackComplete':
            if (this.dataTableCaretAscFeedbackComplete) {
              this.dataTableSorted.sort((a, b) =>
                a.feedback.complete.localeCompare(b.feedback.complete)
              );
              this.dataTableCaretAscFeedbackComplete = false;
            } else {
              this.dataTableSorted.sort((a, b) =>
                b.feedback.complete.localeCompare(a.feedback.complete)
              );
              this.dataTableCaretAscFeedbackComplete = true;
            }
            break;
          default:
            this.dataTableSorted.sort((a, b) => a.name.localeCompare(b.name));
        }
      },
      fetchClassCSVdata() {
        return roundtableServices
          .generateExportableData(this.getCurrentRT.id)
          .then((res) => res.data);
      },
      revealNames() {
        this.reveal_names = !this.reveal_names;
      },
      redirectToStudentFeedback(submissionId, tab) {
        const route = {
          name: 'roundtable.feed',
          query: {
            submissionId: submissionId,
            tab,
          },
        };
        this.$router.replace(route);
        this.$emit('close');
      },
    },
    mounted() {
      this.dataTableSorted = this.table_data;
      this.reveal_names = !this.getCurrentRT.enable_annonymous;
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl'

  .page-container
    margin-bottom: 100px
    overflow-x: auto

  .star {
      color: #fc3;
  }
  .main-content
    padding-bottom:25px
    margin-top: 10px
    width: 1080px
    margin-left: auto
    margin-right: auto

  .export-button-container
    width: 100%
    padding: 0
    margin: 0

  .export-button-container > div
    padding: 0

  button.export-button
      color: #595959
      font-weight: 600
      float: right
      border: 0
      -webkit-box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.3)
      box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.3)
      margin-left: 2px
      margin-right: 10px
      margin-bottom: 10px

  table, td, th {
    border: 1.5px solid lightgray
    border-collapse: collapse
    padding: 9px
  }

  .submission
    background-color: rgba(194, 234, 240, .25)

  .submission-row
     width:300px
  .read-row
      width:100px
  .comments-row
     width:200px

  .assessment-row
    width:230px

  .feedback
    background-color: rgba(205, 250, 221,0.25)

  .comments
      background-color: rgba(255,0,0,0.05);
  .grid-cell
    display: flex;
    justify-content: center
    align-items: center
    text-align: center

  .link-student-feedback
    color: #78D874
    cursor: pointer

  .link-student-submission
    color: #72CCD7
    cursor: pointer

  .student-name-row
    width: 240px
    height: 80px

  .student-container
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: start
    padding-left: 5px

  .avatar
    height=18px
    width=22px

  .avatar-size
    width: 30px
    height: 30px
    img
      height: 100%

  .student-name-cell
    width: 170px
    white-space: nowrap
    overflow: hidden
    display: inline-block
    text-overflow: ellipsis
    vertical-align: middle
    text-align: left
    padding-left: 5px

  .avatar-circlex
    border-radius: 50%
    background-color: pl-fog
    border: 1px solid alpha(pl-slate, 0.3)

  .empty-assessment
    font-size:20px

  .eye-container
      border: 1px solid #AAA8A8
      border-radius: 5px
      padding: 0px 5px

  .tooltip {
      &.info {
        .tooltip-inner {
          padding: 24px;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// individualRoundtableSummaryOverlay.vue?4fd82c71